export const UNITS = [
  { id: "m", name: "m" },
  { id: "cm", name: "cm" },
  { id: "kg", name: "kg" },
];

export const dragNDropConstants = {
  ACTIVITY: "ACTIVITY",
  EMPLOYEE: "EMPLOYEE",
  WORKPLACE: "WORKPLACE",
  STICKYNOTE: "STICKYNOTE",
};

export const spinnerStates = {
  LOADING: "LOADING",
  FAILURE: "FAILURE",
  SUCCESS: "SUCCESS",
};

export const absenceCodes = {
  UD: "Udlån",
  S: "Sygdom",
  K: "Kursus",
  G: "Fri for egen regning",
  BS: "Barn syg",
  V: "Vejrlig",
  FE: "Ferie",
  U: "Ulykke",
  BA: "Barsel",
  FF: "Feriefridag",
  H: "Hjemsendt",
  SH: "Søn og helligdag",
};

export const employeeFunctions = [
  { text: "Formand", value: "Formand" },
  { text: "Teamleder", value: "Teamleder" },
  { text: "Faglært", value: "Faglært" },
  { text: "UFaglært", value: "UFaglært" },
  { text: "Maskinfører", value: "Maskinfører" },
  { text: "Injiceringsoperatør", value: "Injiceringsoperatør" },
  { text: "Rope-access Supervisor", value: "RopeAccessSupervisor" },
  { text: "Rope-access Worker", value: "RopeAccessWorker" },
  { text: "SR", value: "SR" },
  { text: "Trafikoperatør", value: "TrafikOperatør" },
  { text: "Lærling", value: "Lærling" },
  { text: "UnderEntreprenør", value: "UnderEntreprenør" },
  { text: "Funktionær", value: "Funktionær" },
  { text: "Ingen", value: "Ingen" },
];

export const departmentColumns = [
  "Under planlægning",
  "Ordre inde",
  "Tildeles mandskab",
  "Tildelt",
  "Standby",
  "Igang",
  "Afsluttet",
  "Godkendt",
  "Fremsendt",
  "Faktureret",
];

export const showSidebarConst = {
  EMP_WEEK_OVERVIEW: "EMP_WEEK_OVERVIEW",
  EMP_LIST: "EMP_LIST",
  NOT_SHOWING: "NOT_SHOWING",
};

export const measurementTypes = [
  "Injicering",
  "Boring",
  "Boring i smig",
  "Tørboring",
  "Vægsav",
  "Wiresav",
  "Gulvsav",
  "Ringsav",
  "Vinkelsliber - våd",
  "Vinkelsliber - tør",
];



// WEBPACK FOOTER //
// ./src/App/Globals/constants.js